import React, { useEffect } from 'react'
import { Form } from 'antd';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { api } from '../../../../../api/api';
import { TagObj, ObjDB } from '../../../../../types/apiTypes';
import FormStatus from '../../../../../components/form/FormStatus/FormStatus';
import { useFormStatus } from '../../../../../utils/hooks/useFormStatus';
import { TagFormFields } from '../../../../../types/formFieldTypes';
import EditPlaceholder from '../../../../../components/common/EditPlaceholder/EditPlaceholder';
import TagFormInputs from '../TagFormInputs/TagFormInputs';
import { clearTagErrors, initialTagFields, tagValidate } from '../../formData/TagFormData';
import { getAntField } from '../../../../../utils/form';
import { invalidateQueries } from '../../../../../utils/rest';
import { queryKeysTag } from '../../../../../static/data/queryKeys';


type TagEditFormProps = {
    editItem: ObjDB<TagObj> | null
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>
    setEditItem: React.Dispatch<React.SetStateAction<ObjDB<TagObj> | null>>
}

const TagEditForm: React.FC<React.PropsWithChildren<TagEditFormProps>> = React.memo((props) => {
    const {
        editItem, setOpenedForm, setEditItem
    } = props

    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<TagFormFields>({
        initialValues: initialTagFields,
        onSubmit: (values) => {
            mutate(values)
        },
        validate: tagValidate
    })

    const antField = getAntField<TagFormFields>(values, errors, touched)

    const {
        mutate,

    } = useMutation(
        async (values: TagFormFields) => {
            if (editItem) return await api.tags.edit(values, editItem)
        },
        {
            mutationKey: 'tag-edit',
            onSuccess() {
                invalidateQueries(queryKeysTag[0])
                formStatus.setMessage('Данные успешно изменены')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError(err: Error) {
                console.error('ERROR', err)
                formStatus.setMessage(`Ошибка: ${err.message}`)
                formStatus.setStatus('error')
                setTimeout(clearEditItem, 5000)
            },
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialTagFields)
        setErrors(clearTagErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setOpenedForm(false)
        setTimeout(() => {
            setEditItem(null)
            formStatus.reset()
        }, 300)
    }

    const resetChanges = () => {
        if (editItem) {
            const { id, ...fields } = editItem
            setValues(fields)
            setErrors(clearTagErrors)
        }
    }

    useEffect(() => {
        if (editItem) return resetChanges()
        clearForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editItem])


    if (!editItem) return <EditPlaceholder/>

    return (
        <Form
            fields={[antField('name')]}
        >
            {
                editItem &&
                <p className="uif-ant-form-title">
                    ID редактируемого объекта: <span>{editItem.id}</span>
                </p>
            }
            <TagFormInputs
                handleChange={handleChange}
                resetChanges={resetChanges}
                submitForm={submitForm}
            />
            <FormStatus formStatus={formStatus}/>
        </Form>
    )
})

export default TagEditForm